import { TFunctionType } from 'shared/entities/localization';

import {
  ActualNameCreator,
  createActualBlockName,
  normalizeCommonFields
} from '../../block/common';

import {
  ActionReadGoogleSheetsNormalizer,
  IActionReadGoogleSheetsParams
} from './client';

const createActionReadGoogleSheetsActualNameBase = (
  tableName: string | null,
  t: TFunctionType
): string => {
  return tableName
    ? t('block.ActionReadGoogleSheets.actualName', {
        ns: 'entities',
        tableName
      })
    : '';
};

export const createActionReadGoogleSheetsActualName: ActualNameCreator<
  IActionReadGoogleSheetsParams
> = ({ params, t }) =>
  createActionReadGoogleSheetsActualNameBase(params.table?.name || null, t);

export const normalizeActionReadGoogleSheets: ActionReadGoogleSheetsNormalizer =
  (raw, stores) => {
    return {
      ...normalizeCommonFields(raw, stores),
      actualName: (t) =>
        createActualBlockName({
          paramsName: createActionReadGoogleSheetsActualNameBase(
            raw.params.table_name || null,
            t
          ),
          blockKind: raw.kind,
          blockName: raw.name,
          t,
          ...stores
        })
    };
  };
